//#region src/eigen_api_server.ts
var EigenApiServer = /* @__PURE__ */ function(EigenApiServer) {
	EigenApiServer[EigenApiServer["Sandbox1"] = 1] = "Sandbox1";
	EigenApiServer[EigenApiServer["Sandbox2"] = 2] = "Sandbox2";
	EigenApiServer[EigenApiServer["Production1"] = 3] = "Production1";
	EigenApiServer[EigenApiServer["Production2"] = 4] = "Production2";
	return EigenApiServer;
}(EigenApiServer || {});
//#endregion
export { EigenApiServer };

//# sourceMappingURL=eigen_api_server.js.map